import { useEffect, useState } from "react";
import { participantsCardLabelMapper } from "./helper";
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowBack } from "@mui/icons-material";
import TrainingRequestedCandidateList from "./training-request-candidate-list";

const TrainingRequestedListOEM = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { candidatesDetails } = location.state || {};
  const [requestedCandidatesList, setRequestedCandidatesList] = useState([]);
  const [isCompleted, setIsCompleted] = useState(false);
  const [participantsList, setParticipantsList] = useState([]);
  useEffect(() => {
    if (candidatesDetails && candidatesDetails.length) {
      renderCandidateDetails(candidatesDetails);
    }
  }, [candidatesDetails]);
  const renderCandidateDetails = (candidatesDetails) => {
    setParticipantsList(
      candidatesDetails[0].participants.map((data, index) => ({
        serialNumber: index + 1,
        ...data,
      }))
    );
    setIsCompleted(candidatesDetails[0]?.status === "COMPLETED");
    const transformedData = candidatesDetails?.map((listItem, index) => ({
      serialNumber: index + 1,
      oem: listItem?.oem.name,
      numberOfParticipants: listItem?.numberOfParticipants,
      course: listItem?.course.model,
      daysCount: 1,
      venue: listItem?.venue,
      dealerName: listItem?.dealerName,
      state: listItem?.address?.state || "N/A",
      address: listItem?.address?.line1 || "N/A",
      city: listItem?.address?.city || "N/A",
      remarks: listItem?.remarks,
      courseName: listItem?.courseName,
      trainingMode: listItem?.trainingMode,
      status: listItem?.status === "COMPLETED",
      courseStartDate: listItem?.course?.courseDuration.startDate.split("T")[0],
      courseEndDate: listItem?.course?.courseDuration.endDate.split("T")[0],
      rejectionComment: listItem?.rejectionComment || "",
      approvalStatus: listItem?.approvalStatus,
    }));
    setRequestedCandidatesList([...transformedData]);
  };

  const handleBackNavigation = () => {
    navigate("/oem/training/training-approval-status");
  };

  return (
    <>
      <div className="training-request-list-container">
        <div className="training-request-heaeder">
          <ArrowBack fontSize="small" onClick={() => handleBackNavigation()} />
          <div className="title-container">
            <span className="training-title">Training</span>
            <div className="list-title">Training Request Details</div>
          </div>
        </div>
        <div className="request-details-card-container">
          <div className="card-content">
            {requestedCandidatesList.length &&
              participantsCardLabelMapper.map(({ label, value }) => (
                <div className="card-item" key={value}>
                  <div className="card-item-label">{label}:</div>
                  <span className="card-item-value">
                    {requestedCandidatesList[0][value] || "N/A"}
                  </span>
                  {value === "courseName" && (
                    <span
                      className={`training-${requestedCandidatesList[0]?.approvalStatus?.toLowerCase()}`}
                    >
                      {requestedCandidatesList[0]?.approvalStatus}
                    </span>
                  )}
                </div>
              ))}
          </div>
          {requestedCandidatesList[0]?.rejectionComment && (
            <div className="rejection-comment">
              <span className="card-item-label">Rejection Comment:</span>
              <div className="card-item-value">
                {" "}
                {requestedCandidatesList[0]?.rejectionComment}
              </div>
            </div>
          )}
        </div>
        {requestedCandidatesList.length && (
          <div className="participant-list-container">
            <TrainingRequestedCandidateList
              participantsList={participantsList}
              isOEM={true}
              isCompleted={isCompleted}
              courseDetails={candidatesDetails?.[0]}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default TrainingRequestedListOEM;
